import React, { FC } from 'react';
import Modal from '@common/modal';

import classnames from 'classnames/bind';
import styles from './deleteApplyErrorModal.module.scss';

const cx = classnames.bind(styles);

interface IDeleteApplyErrorModalProps {
  visible: boolean;
  onClose: () => void;
}

const DeleteApplyErrorModal: FC<IDeleteApplyErrorModalProps> = ({ visible, onClose }) => {
  return (
    <Modal visible={visible} dimmed={true}>
      <div className={cx('layer')}>
        <strong className={cx('title')}>
          응시 시작 해당월의 응시는
          <br />
          삭제할 수 없습니다.
        </strong>
        <p className={cx('desc')}>현재 기준으로 지난 달의 응시까지 삭제가 가능합니다.</p>
        <div className={cx('btnArea')}>
          <button className={cx('btn')} type="button" onClick={onClose}>
            확인
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteApplyErrorModal;
